import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import appIcon from "@/assets/app-icon.png";
import { useAuth } from "@/hooks/useAuth";
import { WEBVIEW_URL } from "@/lib/siteUrls";

export default function ThankYouPage() {
  const { checkSubscription } = useAuth();

  useEffect(() => {
    void checkSubscription();
  }, [checkSubscription]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6 py-10">
      <div className="text-center max-w-md space-y-5">
        <img src={appIcon} alt="Jobily" className="w-14 h-14 rounded-2xl mx-auto" />

        <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mx-auto">
          <CheckCircle className="w-7 h-7 text-primary" />
        </div>

        <h1 className="font-display font-bold text-xl text-foreground">
          You&apos;re subscribed — thank you!
        </h1>
        <p className="text-sm text-muted-foreground leading-relaxed">
          Jobily Pro is active on your account. Open the extension or web portal to
          use cover letters, autofill, and the rest of your tools.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
          <Button asChild className="h-11">
            <a href={WEBVIEW_URL} target="_blank" rel="noopener noreferrer">
              Open Web Portal
            </a>
          </Button>
          <Button asChild variant="outline" className="h-11">
            <Link to="/webview">Web Portal (this tab)</Link>
          </Button>
        </div>

        <p className="text-xs text-muted-foreground pt-2">
          If the extension still shows an old plan, open{" "}
          <span className="font-medium text-foreground">Settings → Refresh subscription status</span>
          .
        </p>
      </div>
    </div>
  );
}
